export const quotes = [
  { label: 'Helemaal mooi' },
  { label: 'Mand!' },
  { label: 'man man man...' },
  { label: 'kukelekuuu' },
  { label: 'Ha Bier' },
  { label: 'Kom op dan' },
  { label: 'Nitraatje erbij?' },
  { label: 'Kangoeroe' },
  { label: 'Helemaal zand' },
  { label: 'Hondred euro?' },
  { label: 'Plausibel' },
  { label: 'Godmiljaar' },
  { label: 'Mien breur' },
  { label: 'Wegstaan' },
  { label: 'Dit is smeerpijperij' },
  { label: 'Niemand liegt tegen mij' },
  { label: 'Deze petje is echt' },
  { label: 'Ik heb deze tasje aan' },
  { label: 'Woke since 2007' },
  { label: 'Hier had uw advertentie kunn.. oh' },
  { label: 'What, no money?!' },
  { label: 'Official sponsor van de Turbo Polyp' },
  { label: "Here we go let's goooo!" },
  { label: 'Neeeee, beter hè!' },
  { label: 'De verkeerde kaaahnt' },
  { label: 'Alleen toegankelijk met geldige QR-code' },
  { label: 'Ik heb zoveel saus genomen als ik wou' },
  { label: 'Horsefighter!' },
  { label: 'Nu ook live op Twitch' },
  { label: 'Nu ook op VHS' },
  { label: 'Groetjes aan Joris' },
  { label: 'Drommels, drommels, drommels!' },
  { label: 'Iedereen onvoldoende' },
  { label: 'Omruilgarantie tot de deur' },
  { label: 'Poah!' },
  { label: 'G-R-A-T-I-S' },
  { label: 'Lekker Wrap, lekker tastic' },
];
